import styled from 'styled-components';
import PoM000 from 'dc/PoM000';
import { Typ30, Typ41 } from 'dc/Typ';
import Ico36 from 'dc/Ico36';
import Btn21 from 'dc/Btn021';
import Swi03 from 'dc/Swi03';

export const ElementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  margin: 0px;
  width: 100%;
  max-width: 340px;
  position: relative;
`;
export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow:
    0 1px 6px rgba(0, 0, 0, 0.12),
    0 1px 4px rgba(0, 0, 0, 0.12);
`;
export const MetaWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const Input = styled.input`
  border-color: transparent;
  position: relative;
  font-size: 18px;
  line-height: 24px;
  padding: 24px;
  font-weight: normal;
  margin: 0px;
  flex: 1;

  @media (max-width: 767px) {
    padding: 16px;
  }
`;

export const Popup = styled(PoM000)`
  top: 0;
  width: 100%;
  margin-top: 72px;
  padding: 24px;
  text-align: start;

  @media (max-width: 767px) {
    padding: 16px;
    margin-top: 56px;
  }
`;

export const PopupTextError = styled(Typ30)`
  color: #d9464d;
`;

export const PopupText = styled(Typ30)``;

export const ChallengeName = styled(Typ41)``;

export const LeftIcon = styled(Ico36)``;
export const RightIcon = styled(Ico36)``;

type ParticipateButtonProps = {
  disabled?: boolean;
};

export const ParticipateButton = styled(Btn21)<ParticipateButtonProps>`
  width: 100%;
  background-color: #0099a9;

  &:hover {
    ${props => (props.disabled ? 'background-color: #008996' : null)};
  }
`;

export const ToggleButton = styled(Swi03)``;
